import React, { Component } from "react";
import RichTextEditor from "RichTextEditor";
import RichTextTinymceEditor from "RichTextTinymceEditor";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import CreatableSelect from "react-select/creatable";
import Button from "react-bootstrap-button-loader";
import DatePicker from "react-datepicker";
import TimePicker from "rc-time-picker";
import moment from "moment";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import { CompactPicker, SketchPicker } from "react-color";
import reactCSS from "reactcss";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import {
  DATE_FORMAT,
  DATE_FORMAT_WITH_TIME,
  DATE_FORMAT_FNS,
  DATE_FORMAT_WITH_TIME_FNS,
  DISPLAY_DATE_FORMAT,
  DISPLAY_LOCAL_DATE_FORMAT,
  checkDateFormatYMD,
} from "Constants";
import LocaleStrings from "Languages";
import _ from "lodash";
import { parse } from "date-fns";
import InputMask from "react-input-mask";

export var trimValue = (value) => value && value.trim();
export var notOnlySpecialChar = (value) =>
  value && !/^[a-zA-Z0-9- ]*$/.test(value)
    ? "Name can not contain special characters"
    : undefined;
export var LABEL_POSITION_TOP = "TOP";
export var LABEL_POSITION_LEFT = "LEFT";

// ======================== redux-form validate props variables ========================
export const required = (value) => (value ? undefined : "Required");
export const maxLength = (max) => (value) =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined;
// const maxLength15 = maxLength(15)
export const minLength = (min) => (value) =>
  value && value.length < min ? `Must be ${min} characters or more` : undefined;
// export const minLength2 = minLength(2)
export const number = (value) =>
  value && isNaN(Number(value)) ? "Must be a number" : undefined;
export const minValue = (min) => (value) =>
  value && value < min ? `Must be at least ${min}` : undefined;
export const maxValue = (max) => (value) =>
  value && value > max ? `Must be at most ${max}` : undefined;
// export const minValue13 = minValue(13)
export const email = (value) =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? "Invalid email address"
    : undefined;
export const tooYoung = (value) =>
  value && value < 13
    ? "You do not meet the minimum age requirement!"
    : undefined;
export const aol = (value) =>
  value && /.+@aol\.com/.test(value)
    ? "Really? You still use AOL for your email?"
    : undefined;
export const alphaNumeric = (value) =>
  value && /[^a-zA-Z0-9 ]/i.test(value)
    ? "Only alphanumeric characters"
    : undefined;
export const noSpecialChar = (value) =>
  value && !/^[a-zA-Z0-9 ]*$/.test(value)
    ? "Can not contain special characters"
    : undefined;
export const phoneNumber = (value) =>
  value && !/^(0|[1-9][0-9]{9})$/i.test(value)
    ? "Invalid phone number, must be 10 digits"
    : undefined;

// ======================== redux-form normalize props variables ========================
export var trim = (value) => value && value.trim();
export const upper = (value) => value && value.toUpperCase();
export const lower = (value) => value && value.toLowerCase();
export const lessThan = (otherField) => (value, previousValue, allValues) =>
  value < allValues[otherField] ? value : previousValue;
export const greaterThan = (otherField) => (value, previousValue, allValues) =>
  value > allValues[otherField] ? value : previousValue;

// *********** Tried trim formatter for 'redux-form' format props but didn't work (dated: Sep 25, 2020) *********** //
// ======================== redux-form format props variables ========================
export var trimFormat = (value) => {
  if (!value) return "";
  return value.trim();
};
// export var trimFormat = value => {return value.trim()}
// export var trimFormat = value => value && value.trim()
// ************************************************************************************************************** //

export class BaseComponent extends Component {
  renderFieldText(field) {
    let charactersLeft = "";
    var labelposition = field.labelposition;
    var formdiv = "";
    if (field.formdiv !== undefined && field.formdiv === "false") {
      formdiv = "";
    }
    var divClassName = `form-group row ${formdiv} ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName} ${field.bsClass ? field.bsClass : ""}`;
    var labelClasses = "control-label col-sm-3";
    var inputClasses = "col-sm-9 col-sm-offset-0";

    if (labelposition === LABEL_POSITION_TOP) {
      labelClasses = "control-label-top col-sm-12";
      inputClasses = "col-sm-12 col-sm-offset-0";
    }
    if (field.maxlength) {
      charactersLeft = field.maxlength - field.input.value.length;
    }
    return (
      <div className={divClassName}>
        {field.label && field.label !== "" ? (
          <label className={labelClasses}>
            {field.label}
            <span className="label-mandatory">
              {field.mandatory === "true" ? "*" : ""}
            </span>

            {field.labelinfo && field.labelinfo !== "" ? (
              <OverlayTrigger
                key="auocompleteasync"
                placement="right"
                overlay={
                  <Tooltip id="tooltip-category" style={{ marginTop: "-5px" }}>
                    <div className="custom-text1-white-normal">
                      {field.labelinfo}
                    </div>
                  </Tooltip>
                }
              >
                <img
                  src="../../style/images/header-icons/infoicon.png"
                  className="ml-10 pointer"
                  alt="info icon"
                />
              </OverlayTrigger>
            ) : (
              ""
            )}
          </label>
        ) : null}
        <div className={inputClasses} style={{ position: "relative" }}>
          {field.type === "password" ? (
            <input
              className="form-control"
              type={field.type}
              placeholder={field.placeholder}
              {...field.input}
              maxLength={field.maxlength ? field.maxlength : ""}
              autoComplete="new-password"
            />
          ) : field.type === "number" ? (
            <input
              className="form-control"
              type={field.type}
              placeholder={field.placeholder}
              {...field.input}
              disabled={field.disabled === true ? true : false}
              maxLength={field.maxlength ? field.maxlength : ""}
              min={field.min ? field.min : ""}
              max={field.max ? field.max : ""}
              step={field.step ? field.step : "any"}
            />
          ) : (
            <input
              className="form-control"
              type={field.type}
              placeholder={field.placeholder}
              {...field.input}
              disabled={field.disabled === true ? true : false}
              maxLength={field.maxlength ? field.maxlength : ""}
            />
          )}
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
          {field.maxlength ? (
            <span className="char-left">
              {field.input.value.length}
              {" / "}
              {field.maxlength}
            </span>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }

  renderHiddenFieldText(field) {
    var divClassName = `row ${field.meta.error ? "has-danger" : ""}`;
    divClassName = `${divClassName} ${field.bsClass ? field.bsClass : ""}`;
    var inputClasses = "col-sm-12 col-sm-offset-0";

    return (
      <div className={divClassName}>
        <div className={inputClasses} style={{ display: "none" }}>
          <input
            className="form-control"
            type={field.type}
            placeholder={field.placeholder}
            {...field.input}
          />
        </div>

        {field.meta.error ? (
          <div className="col-sm-12 text-help label-text-help mb-1">
            {field.meta.error}
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }

  renderNumberWithCountryField(field) {
    var labelposition = field.labelposition;
    var divClassName = `form-group row ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName} ${field.bsClass ? field.bsClass : ""}`;
    var labelClasses = "control-label col-sm-3";
    var inputClasses = "col-sm-9 col-sm-offset-0";

    if (labelposition === LABEL_POSITION_TOP) {
      labelClasses = "control-label-top col-sm-12";
      inputClasses = "col-sm-12 col-sm-offset-0";
    }

    return (
      <div className={divClassName}>
        {field.label && field.label !== "" ? (
          <label className={labelClasses}>
            {field.label}
            <span className="label-mandatory">
              {field.mandatory === "true" ? "*" : ""}
            </span>

            {field.labelinfo && field.labelinfo !== "" ? (
              <OverlayTrigger
                key="auocompleteasync"
                placement="right"
                overlay={
                  <Tooltip id="tooltip-category" style={{ marginTop: "-5px" }}>
                    <div className="custom-text1-white-normal">
                      {field.labelinfo}
                    </div>
                  </Tooltip>
                }
              >
                <img
                  src="../../style/images/header-icons/infoicon.png"
                  className="ml-10 pointer"
                  alt="info icon"
                />
              </OverlayTrigger>
            ) : (
              ""
            )}
          </label>
        ) : null}
        <div className={inputClasses} style={{ position: "relative" }}>
          <PhoneInput
            country={"us"}
            enableSearch={true}
            countryCodeEditable={false}
            placeholder={""}
            disabled={field.disabled === true ? true : false}
            name={field.input.name}
            value={field.input.value.toString()}
            onChange={(e) => {
              field.input.onChange(e);
            }}
          />

          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>
      </div>
    );
  }

  renderFieldTextarea(field) {
    let charactersLeft = "";
    if (field.maxlength) {
      charactersLeft = field.maxlength - field.input.value.length;
    }
    var labelposition = field.labelposition;
    var divClassName = `form-group row ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName} ${field.bsClass}`;

    var labelClasses = "control-label col-sm-3";
    var inputClasses = "col-sm-9 col-sm-offset-0";

    if (labelposition === LABEL_POSITION_TOP) {
      labelClasses = "control-label-top col-sm-12";
      inputClasses = "col-sm-12 col-sm-offset-0";
    }
    return (
      <div className={divClassName}>
        {field.label && field.label !== "" ? (
          <label className={labelClasses}>
            {field.label}
            <span className="label-mandatory">
              {field.mandatory === "true" ? "*" : ""}
            </span>
          </label>
        ) : (
          ""
        )}
        <div className={inputClasses} style={{ position: "relative" }}>
          <textarea
            className="form-control"
            placeholder={field.placeholder}
            {...field.input}
            maxLength={field.maxlength ? field.maxlength : ""}
            disabled={field.disabled === true ? true : false}
          ></textarea>
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
          {field.maxlength ? (
            <span className="char-left">
              {field.input.value.length}
              {" / "}
              {field.maxlength}
            </span>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }

  renderCheckbox(field) {
    let { label, opts, input, meta } = field;
    var divClassName = `form-group row ${
      meta.touched && meta.error ? "has-danger" : ""
    }`;

    return (
      <div className={divClassName}>
        {field.label && field.label !== "" ? (
          <label className="control-label-top col-sm-12">
            {label}
            <span className="label-mandatory">
              {field.mandatory === "true" ? "*" : ""}
            </span>
          </label>
        ) : (
          ""
        )}
        <div className="col-sm-12 col-sm-offset-0">
          {opts.map((option, index) => {
            return (
              <div key={index}>
                <label
                  className="custom-container-checkbox"
                  style={{ marginBottom: 5 }}
                >
                  {option.text}
                  <input
                    type="checkbox"
                    name={`${input.name}[${index}]`}
                    id={`${input.name}[${index}]`}
                    value={option.value}
                    checked={input.value.indexOf(option.value) !== -1}
                    onChange={(event) => {
                      const newValue = [...input.value];
                      if (event.target.checked) {
                        newValue.push(option.value);
                      } else {
                        newValue.splice(newValue.indexOf(option.value), 1);
                      }
                      return input.onChange(newValue);
                    }}
                  />
                  <span className="checkmark" />
                </label>
              </div>
            );
          })}
          <div className="text-help label-text-help">
            {meta.touched ? meta.error : ""}
          </div>
        </div>
      </div>
    );
  }

  renderHiddenCheckbox(field) {
    let { opts, input, meta } = field;
    var divClassName = `row ${meta.touched && meta.error ? "has-danger" : ""}`;

    return (
      <div className={divClassName}>
        <div className="col-sm-12 col-sm-offset-0" style={{ display: "none" }}>
          {opts.map((option, index) => {
            return (
              <div key={index}>
                <label>
                  {option.text}
                  <input
                    type="checkbox"
                    name={`${input.name}[${index}]`}
                    id={`${input.name}[${index}]`}
                    value={option.value}
                    checked={input.value.indexOf(option.value) !== -1}
                    onChange={(event) => {
                      const newValue = [...input.value];
                      if (event.target.checked) {
                        newValue.push(option.value);
                      } else {
                        newValue.splice(newValue.indexOf(option.value), 1);
                      }
                      return input.onChange(newValue);
                    }}
                  />
                </label>
              </div>
            );
          })}
          <div className="text-help label-text-help">
            {meta.touched ? meta.error : ""}
          </div>
        </div>
      </div>
    );
  }

  renderReactMultiSelectCheckboxesWithManageButton(field) {
    var { opts, input, placeholder, labelposition, meta } = field;
    var defaultVal = input.value;
    var values = [];
    var selected = [];
    var defaultLabel = { placeholderButtonLabel: placeholder, value: [] };

    if (defaultVal && defaultVal != "") {
      if (Array.isArray(defaultVal)) {
        values = defaultVal;
      } else {
        values = defaultVal.toString().split(",");
      }

      values.forEach((item) => {
        var added = _.filter(opts, (obj) => {
          return obj.value == item;
        });
        selected.push(added[0]);
      });

      defaultLabel.value = selected;
    }

    var divClassName = `form-group row ${
      meta.invalid && meta.error ? "has-danger" : ""
    }`;
    var labelClasses = "control-label col-sm-3";
    var inputClasses = "col-sm-5 col-sm-offset-0";
    var buttonClasses = "col-sm-4 col-sm-offset-0 text-right";

    if (labelposition === LABEL_POSITION_TOP) {
      labelClasses = "control-label-top col-sm-12 m-0 mb-5";
      inputClasses = "col-sm-8 col-sm-offset-0 pr-0";
      buttonClasses = "col-sm-4 col-sm-offset-0 text-right";
    }

    return (
      <div className={divClassName}>
        {field.label && field.label !== "" ? (
          <label className={labelClasses}>
            {field.label}
            <span className="label-mandatory">
              {field.mandatory === "true" ? "*" : ""}
            </span>
          </label>
        ) : (
          ""
        )}
        <div className={inputClasses}>
          <ReactMultiSelectCheckboxes
            {...input.value}
            value={selected}
            onChange={(opts) => {
              return input.onChange(opts.map((p) => p.value));
            }}
            placeholderButtonLabel={placeholder}
            getDropdownButtonLabel={(defaultLabel) => {
              return Array.isArray(defaultLabel.value) &&
                defaultLabel.value.length > 0
                ? `${defaultLabel.value.length} Selected`
                : placeholder;
            }}
            options={opts}
            className="react-multi-select-checkboxes-custom-css"
          />
          <div className="text-help label-text-help">
            {meta.invalid && meta.error ? meta.error : ""}
          </div>
        </div>
        <div className={`${buttonClasses}`}>
          <Button className="btn btn-custom-blue" onClick={field.onManageClick}>
            {LocaleStrings.button_manage_category}
          </Button>
        </div>
      </div>
    );
  }

  renderReactMultiSelectCheckboxes(field) {
    var { opts, input, placeholder, labelposition, meta } = field;
    var defaultVal = input.value;
    var values = [];
    var selected = [];
    var defaultLabel = { placeholderButtonLabel: placeholder, value: [] };

    if (defaultVal && defaultVal != "") {
      if (Array.isArray(defaultVal)) {
        values = defaultVal;
      } else {
        values = defaultVal.toString().split(",");
      }

      values.forEach((item) => {
        var added = _.filter(opts, (obj) => {
          return obj.value == item;
        });
        selected.push(added[0]);
      });

      defaultLabel.value = selected;
    }

    var divClassName = `form-group row ${
      meta.invalid && meta.error ? "has-danger" : ""
    }`;
    var labelClasses = "control-label col-sm-3";
    var inputClasses = "col-sm-9 col-sm-offset-0";

    if (labelposition === LABEL_POSITION_TOP) {
      labelClasses = "control-label-top col-sm-12";
      inputClasses = "col-sm-12 col-sm-offset-0";
    }

    return (
      <div className={divClassName}>
        {field.label && field.label !== "" ? (
          <label className={labelClasses}>
            {field.label}
            <span className="label-mandatory">
              {field.mandatory === "true" ? "*" : ""}
            </span>
          </label>
        ) : (
          ""
        )}
        <div className={inputClasses}>
          <ReactMultiSelectCheckboxes
            {...input.value}
            value={selected}
            onChange={(opts) => {
              return input.onChange(opts.map((p) => p.value));
            }}
            placeholderButtonLabel={placeholder}
            getDropdownButtonLabel={(defaultLabel) => {
              return Array.isArray(defaultLabel.value) &&
                defaultLabel.value.length > 0
                ? `${defaultLabel.value.length} Selected`
                : placeholder;
            }}
            options={opts}
            className="react-multi-select-checkboxes-custom-css"
          />
          <div className="text-help label-text-help">
            {meta.invalid && meta.error ? meta.error : ""}
          </div>
        </div>
      </div>
    );
  }

  renderSelect(field) {
    var divClassName = `form-group row ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;

    var labelClasses = "control-label col-sm-3";
    var inputClasses = "col-sm-9 col-sm-offset-0";

    if (field.labelposition === LABEL_POSITION_TOP) {
      labelClasses = "control-label-top col-sm-12";
      inputClasses = "col-sm-12 col-sm-offset-0";
    }

    return (
      <div className={divClassName}>
        {field.label && field.label !== "" ? (
          <label className={labelClasses}>
            {field.label}
            <span className="label-mandatory">
              {field.mandatory === "true" ? "*" : ""}
            </span>
          </label>
        ) : (
          ""
        )}
        <div className={inputClasses}>
          <select
            className="form-control dropdown-height-border"
            {...field.input}
            disabled={field.disabled === true ? true : false}
          >
            {field.placeholder ? (
              <option value="" key={field.label}>
                {field.placeholder}
              </option>
            ) : (
              ""
            )}
            {field.opts.map((object, index) => {
              return (
                <option key={`${object.value}-${index}`} value={object.value}>
                  {object.name ? object.name : object.text}
                </option>
              );
            })}
          </select>
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>
      </div>
    );
  }

  renderDatalistSelect(field) {
    let charactersLeft = "";
    var divClassName = `form-group row ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;

    var labelClasses = "control-label col-sm-3";
    var inputClasses = "col-sm-9 col-sm-offset-0";

    if (field.labelposition === LABEL_POSITION_TOP) {
      labelClasses = "control-label-top col-sm-12";
      inputClasses = "col-sm-12 col-sm-offset-0";
    }
    if (field.maxlength) {
      charactersLeft = field.maxlength - field.input.value.length;
    }
    return (
      <div className={divClassName}>
        {field.label && field.label !== "" ? (
          <label className={labelClasses}>
            {field.label}
            <span className="label-mandatory">
              {field.mandatory === "true" ? "*" : ""}
            </span>
          </label>
        ) : (
          ""
        )}
        <div
          className="col-sm-12 col-sm-offset-0"
          style={{ position: "relative" }}
        >
          <input
            className="form-control"
            type={field.type}
            placeholder={field.placeholder}
            {...field.input}
            list={field.list}
          />
          <datalist id={field.list}>
            {field.datalistoptn.map((item, key) => (
              <option key={key} value={item.value} />
            ))}
          </datalist>
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
          {field.maxlength ? (
            <span className="char-left">
              {field.input.value.length}
              {" / "}
              {field.maxlength}
            </span>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }

  renderSelectWithDelete(field) {
    var divClassName = `form-group row ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;

    return (
      <div className={divClassName}>
        {field.label && field.label !== "" ? (
          <label className="control-label-top col-sm-12 mt-0">
            {field.label}
            <span className="label-mandatory">
              {field.mandatory === "true" ? "*" : ""}
            </span>
          </label>
        ) : (
          ""
        )}
        <div className="col-sm-12 col-sm-offset-0 d-flex">
          <select className="form-control" {...field.input}>
            <option value="" key={field.label}>
              {field.placeholder}
            </option>
            {field.opts.map((object, index) => {
              return (
                <option key={`${object.value}-${index}`} value={object.value}>
                  {object.name}
                </option>
              );
            })}
          </select>
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
          {/* </div> */}
          {/* <div className="col-sm-2"> */}
          <Button
            type="button"
            className="i-custom-table-delete ml-10"
            onClick={field.deleteaction}
          >
            <img
              className="i-custom-table"
              src="../../style/images/custom-icons/icons8-close.svg"
            />
          </Button>
        </div>
      </div>
    );
  }

  // // Before adding datefns
  // renderDatePicker(field) {
  //   //debugger;
  //   var { input, selected, disabled, minDate } = field;

  //   var value = input.value ? moment(input.value) : null;
  //   var selectedValue = value ? value : selected;

  //   var divClassName = `form-group row ${
  //     field.meta.touched && field.meta.error ? "has-danger" : ""
  //   }`;
  //   divClassName = `${divClassName} ${field.bsClass}`;
  //   var labelClasses = "control-label-top col-sm-12";
  //   var inputClasses = "col-sm-12 col-sm-offset-0";

  //   return (
  //     <div className={divClassName}>
  //       <label className={labelClasses}>
  //         {field.label}
  //         <span className="label-mandatory">
  //           {field.mandatory === "true" ? "*" : ""}
  //         </span>
  //       </label>
  //       <div className={inputClasses}>
  //         <DatePicker
  //           {...input}
  //           value={value}
  //           selected={selectedValue}
  //           className="form-control"
  //           dateFormat={DATE_FORMAT}
  //           disabled={disabled}
  //           minDate={field.minDate ? field.minDate : ""}
  //           name={input.name}
  //           onKeyDown={(e) => {
  //             e.preventDefault();
  //           }}
  //         />
  //         <div className="text-help label-text-help">
  //           {field.meta.touched ? field.meta.error : ""}
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }

  renderDatePicker(field) {
    var { input, disabled, labelposition, placeholder } = field;
    var selectedValue = input?.value
      ? input.value
      : field?.selected
      ? field.selected
      : null;

    // console.log("Type :- ", typeof selectedValue);
    // console.log("selectedValue -----:- ", selectedValue);

    if (typeof selectedValue === "string") {
      let date = "";

      // Check 'YYYY-MM-DD' format, this format is coz we are storing the date in this format, and as per format convert string date to object.
      if (!checkDateFormatYMD(selectedValue)) {
        date = moment(selectedValue, `${DISPLAY_LOCAL_DATE_FORMAT}`).format(
          DATE_FORMAT
        );
      } else {
        // let dateParse = new Date(Date.parse(selectedValue));
        // date = moment(dateParse).format(DATE_FORMAT);

        date = moment(selectedValue).format(DATE_FORMAT);
      }

      // console.log("date", date);
      // if (!isNaN(new Date(date))) {
      if (!moment(date).isValid()) {
        selectedValue = "";
      } else {
        selectedValue = parse(date, DATE_FORMAT_FNS, new Date());
      }
    }

    input.value = selectedValue;
    // console.log("selectedValue :- ", selectedValue);
    // console.log("input :- ", input);

    var divClassName = `form-group row ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName} ${field.bsClass}`;
    var labelClasses = "control-label col-sm-3";
    var inputClasses = "col-sm-9 col-sm-offset-0";

    if (labelposition === LABEL_POSITION_TOP) {
      labelClasses = "control-label-top col-sm-12";
      inputClasses = "col-sm-12 col-sm-offset-0";
    }

    return (
      <div className={divClassName}>
        {field.label && field.label !== "" ? (
          <label className={labelClasses}>
            {field.label}
            <span className="label-mandatory">
              {field.mandatory === "true" ? "*" : ""}
            </span>
          </label>
        ) : (
          ""
        )}
        <div className={inputClasses}>
          <DatePicker
            {...input}
            selected={selectedValue}
            className="form-control"
            // isClearable
            placeholderText={placeholder ? placeholder : ""}
            dateFormat={DISPLAY_DATE_FORMAT}
            minDate={field.minDate ? field.minDate : ""}
            disabled={disabled}
            // onKeyDown={(e) => {
            //   // e.preventDefault();
            // }}
            onChange={input.onChange}
          />
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>
      </div>
    );
  }

  renderDateTimePicker(field) {
    // console.log('field :- ', field);
    const {
      input,
      disabled,
      label,
      labelposition,
      meta,
      mandatory,
      placeholder,
    } = field;
    var selectedValue = input?.value
      ? input.value
      : field?.selected
      ? field.selected
      : null;

    // console.log("Type :- ", typeof selectedValue);
    // console.log("selectedValue -----:- ", selectedValue);

    if (typeof selectedValue == "string" && selectedValue !== "") {
      let date = "";
      var regex = new RegExp(
        /[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1]) (2[0-3]|[01][0-9]):[0-5][0-9]/
      );

      // Check 'YYYY-MM-DD HH:mm' format, this format is coz we are storing the date in this format, and as per format conver string date to object.
      if (!regex.test(selectedValue)) {
        date = moment(
          selectedValue,
          `${DISPLAY_LOCAL_DATE_FORMAT} HH:mm`
        ).format(DATE_FORMAT_WITH_TIME);
      } else {
        date = moment(selectedValue).format(DATE_FORMAT_WITH_TIME);
      }

      // console.log("date", date);

      selectedValue = parse(date, DATE_FORMAT_WITH_TIME_FNS, new Date());
    }

    input.value = selectedValue;
    // console.log("selectedValue :- ", selectedValue);
    // console.log("input :- ", input);

    var divClassName = `form-group row ${
      meta.touched && meta.error ? "has-danger" : ""
    }`;
    var labelClasses = "control-label col-sm-3";
    var inputClasses = "col-sm-9 col-sm-offset-0";

    if (labelposition === LABEL_POSITION_TOP) {
      labelClasses = "control-label-top col-sm-12";
      inputClasses = "col-sm-12 col-sm-offset-0";
    }

    return (
      <div className={divClassName}>
        {label !== "" ? (
          <label className={labelClasses}>
            {label}
            <span className="label-mandatory">
              {mandatory && mandatory === "true" ? "*" : ""}
            </span>
          </label>
        ) : null}

        <div className={inputClasses}>
          <DatePicker
            {...input}
            selected={selectedValue}
            className="form-control"
            // isClearable
            placeholderText={placeholder ? placeholder : ""}
            minDate={field.minDate ? field.minDate : ""}
            showTimeSelect
            timeIntervals={1}
            timeFormat={`HH:mm`}
            dateFormat={`${DISPLAY_DATE_FORMAT} HH:mm`}
            disabled={disabled}
            onChange={input.onChange}
          />
          <div className="text-help label-text-help">
            {meta.touched ? meta.error : ""}
          </div>
        </div>
      </div>
    );
  }

  renderTimePicker(field) {
    // debugger;
    var { input } = field;
    // console.log("input.value :- ", input.value);
    var value = input.value ? input.value : field.selected;
    if (typeof value == "string") {
      value = moment(`${field.selectedDate} ${value}`);
    }
    // console.log("value-------- : - ", input.name, value);

    var divClassName = `form-group row ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName} ${field.bsClass}`;
    var labelClasses = "control-label-top col-sm-12";
    var inputClasses = "col-sm-12 col-sm-offset-0";

    return (
      <div className={divClassName}>
        {field.label && field.label !== "" ? (
          <label className={labelClasses}>
            {field.label}
            <span className="label-mandatory">
              {field.mandatory === "true" ? "*" : ""}
            </span>
          </label>
        ) : (
          ""
        )}
        <div className={inputClasses}>
          <TimePicker
            {...input}
            className="w-100"
            placeholder={field.placeholder}
            showSecond={false}
            value={value}
            onChange={(e) => {
              input.onChange(e);
            }}
            inputReadOnly
          />
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>
      </div>
    );
  }

  renderRichTextarea(field) {
    var divClassName = `form-group ${divClassName}`;
    return (
      <div className={divClassName}>
        <RichTextEditor type={field.type} {...field} />
        <div className="text-help label-text-help">
          {field.meta.touched ? field.meta.error : ""}
        </div>
      </div>
    );
  }

  renderRichTextareaWithLabel(field) {
    var labelposition = field.labelposition;
    var divClassName = `form-group row ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName} ${field.bsClass}`;

    var labelClasses = "control-label col-sm-3";
    var inputClasses = "col-sm-9 col-sm-offset-0";

    if (labelposition === LABEL_POSITION_TOP) {
      labelClasses = "control-label-top col-sm-12";
      inputClasses = "col-sm-12 col-sm-offset-0";
    }
    return (
      <div className={divClassName}>
        {field.label && field.label !== "" ? (
          <label className={labelClasses}>
            {field.label}
            <span className="label-mandatory">
              {field.mandatory === "true" ? "*" : ""}
            </span>
          </label>
        ) : (
          ""
        )}
        <div className={inputClasses} style={{ paddingRight: 37 }}>
          <RichTextEditor type={field.type} {...field} />
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>
      </div>
    );
  }

  renderRichTextareaWithLabelTinymce(field) {
    let charactersLeft = "";
    var labelposition = field.labelposition;
    var divClassName = `form-group row ${field.meta.error ? "has-danger" : ""}`;

    var labelClasses = "control-label col-sm-3";
    var inputClasses = "col-sm-9 col-sm-offset-0";

    if (labelposition === LABEL_POSITION_TOP) {
      labelClasses = "control-label-top col-sm-12";
      inputClasses = "col-sm-12 col-sm-offset-0";
    }

    if (field.maxlength) {
      charactersLeft = field.maxlength - field.input.value.length;
    }
    return (
      <div className={divClassName}>
        {field.label && field.label !== "" ? (
          <label className={labelClasses}>
            {field.label}
            <span className="label-mandatory">
              {field.mandatory === "true" ? "*" : ""}
            </span>
          </label>
        ) : (
          ""
        )}
        <div className={inputClasses} style={{ position: "relative" }}>
          <RichTextTinymceEditor type={field.type} {...field} />
          <div className="text-help label-text-help">
            {field.meta.error ? field.meta.error : ""}
          </div>
          {/* {field.maxlength ? <span className="char-left">{charactersLeft}{' '}{LocaleStrings.characters_left}</span> : ""} */}
        </div>
      </div>
    );
  }

  // renderAutoCompleteAsync1(field) {
  //   const { input, label, placeholder, labelposition, meta, loadOptions } =
  //     field;

  //   var divClassName = `form-group row ${
  //     meta.error && meta.error ? "has-danger" : ""
  //   }`;
  //   divClassName = `${divClassName} ${field.bsClass}`;

  //   var labelClasses = "control-label-top col-sm-12";
  //   var inputClasses = "col-sm-12";

  //   if (labelposition === LABEL_POSITION_LEFT) {
  //     labelClasses = "control-label col-xs-12 col-sm-12 col-md-3";
  //     inputClasses = "col-12 col-sm-12 col-md-9";
  //   }

  //   return (
  //     <div className={divClassName}>
  //       {label !== "" ? (
  //         <label className={labelClasses}>
  //           {label}
  //           <span className="label-mandatory">
  //             {field.mandatory === "true" ? "*" : ""}
  //           </span>
  //         </label>
  //       ) : null}
  //       <div className={inputClasses}>
  //         <AsyncSelect
  //           className="input-field react-select"
  //           placeholder={placeholder}
  //           value={input?.value}
  //           isClearable={true}
  //           loadOptions={loadOptions}
  //           onChange={(v) => input.onChange(v)}
  //         />

  //         <div className="text-help">{meta.error ? meta.error : ""}</div>
  //       </div>
  //     </div>
  //   );
  // }

  renderAutoCompleteAsync(field) {
    var divClassName = `form-group row ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName} ${field.bsClass}`;

    var labelClasses = "control-label col-sm-3";
    var inputClasses = "col-sm-9 col-sm-offset-0";

    if (field.labelposition === LABEL_POSITION_TOP) {
      labelClasses = "control-label-top col-sm-12";
      inputClasses = "col-sm-12 col-sm-offset-0";
    }

    return (
      <div className={divClassName}>
        {field.label && field.label !== "" ? (
          <>
            <label className={labelClasses}>
              {field.label}
              <span className="label-mandatory">
                {field.mandatory === "true" ? "*" : ""}
              </span>

              {field.labelinfo && field.labelinfo !== "" ? (
                <OverlayTrigger
                  key="auocompleteasync"
                  placement="right"
                  overlay={
                    <Tooltip
                      id="tooltip-category"
                      style={{ marginTop: "-5px" }}
                    >
                      <div className="custom-text1-white-normal">
                        {field.labelinfo}
                      </div>
                    </Tooltip>
                  }
                >
                  <img
                    src="../../style/images/header-icons/infoicon.png"
                    className="ml-10 pointer"
                    alt="info icon"
                  />
                </OverlayTrigger>
              ) : (
                ""
              )}
            </label>
          </>
        ) : (
          ""
        )}
        <div className={inputClasses}>
          <AsyncSelect
            className="react-multi-select-custom-css"
            placeholder={field.placeholder}
            {...field.input}
            isMulti={false}
            value={field.input.value || ""}
            valueKey={field.valueKey}
            labelKey={field.labelKey}
            loadOptions={field.loadOptions}
            // onChange={(v) => input.onChange(v)}
            // onBlur={() => field.input.onBlur(field.input.value)}
            isDisabled={field.disabled === true ? true : false}
            isClearable
            onBlur={(event) => {
              event.preventDefault();
            }}
          />
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>
      </div>
    );
  }

  renderAutoComplete(field) {
    // console.log("field :- ", field);
    var divClassName = `form-group row ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName} ${field.bsClass}`;

    var labelClasses = "control-label-top col-sm-12";
    var inputClasses = "col-sm-12 col-sm-offset-0";
    if (field.labelposition === LABEL_POSITION_LEFT) {
      labelClasses = "control-label col-sm-3";
      inputClasses = "col-sm-9 col-sm-offset-0";
    }

    // console.log(typeof field.input.value);

    // Below code is updated by vinay on 25-03-2025 as this was validating single select value.

    // if (typeof field.input.value !== "object") {
    //   field.input.value = _.filter(field.options, function (o) {
    //     if (
    //       o.value === field.input.value ||
    //       parseInt(o.value) === parseInt(field.input.value)
    //     ) {
    //       return o;
    //     }
    //   });
    // }

    // New code
    let allinputval = field.input.value;
    let SelectedArrtObj = [];
    if (
      typeof allinputval !== "object" &&
      allinputval !== "" &&
      _.size(field.options) > 0
    ) {
      var nameArr = allinputval.toString().split(",");
      // console.log("nameArr :- ", nameArr);

      _.forEach(nameArr, function (values) {
        let obj = {};
        let filterValues = _.filter(field.options, (o) => {
          return o.value == values;
        });

        if (filterValues && filterValues.length > 0) {
          SelectedArrtObj.push(filterValues[0]);
        }
      });
      // console.log("SelectedArrtObj :- ", SelectedArrtObj);

      if (_.size(SelectedArrtObj) > 0) {
        field.input.value = SelectedArrtObj;
      }
    }
    // onblur function changed by udayan and vinay for iphone changes
    return (
      <div className={divClassName}>
        {field.label && field.label !== "" ? (
          <label className={labelClasses}>
            {field.label}
            <span className="label-mandatory">
              {field.mandatory === "true" ? "*" : ""}
            </span>

            {field.labelinfo && field.labelinfo !== "" ? (
              <OverlayTrigger
                key="auocompleteasync"
                placement="right"
                overlay={
                  <Tooltip id="tooltip-category" style={{ marginTop: "-5px" }}>
                    <div className="custom-text1-white-normal">
                      {field.labelinfo}
                    </div>
                  </Tooltip>
                }
              >
                <img
                  src="../../style/images/header-icons/infoicon.png"
                  className="ml-10 pointer"
                  alt="info icon"
                />
              </OverlayTrigger>
            ) : (
              ""
            )}
          </label>
        ) : (
          ""
        )}
        <div className={inputClasses}>
          <Select
            {...field.input}
            className="react-multi-select-custom-css"
            placeholder={field.placeholder}
            value={field.input.value || ""}
            labelKey={field.labelKey}
            valueKey={field.valueKey}
            isMulti={field.isMulti ? true : false}
            options={field.options}
            // onBlur={() => field.input.onBlur(field.input.value)}
            isClearable
            onBlur={(event) => {
              event.preventDefault();
            }}
          />
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>
      </div>
    );
  }

  renderCreateableSelect(field) {
    // console.log("field :- ", field);
    var divClassName = `form-group row ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName} ${field.bsClass}`;

    var labelClasses = "control-label col-sm-3";
    var inputClasses = "col-sm-9 col-sm-offset-0";

    if (field.labelposition === LABEL_POSITION_TOP) {
      labelClasses = "control-label-top col-sm-12";
      inputClasses = "col-sm-12 col-sm-offset-0";
    }

    // console.log(typeof field.input.value);

    // New code
    let allinputval = field.input.value;
    let SelectedArrtObj = [];
    if (
      typeof allinputval !== "object" &&
      allinputval !== "" &&
      _.size(field.options) > 0
    ) {
      var nameArr = allinputval.toString().split(",");
      // console.log("nameArr :- ", nameArr);

      _.forEach(nameArr, function (values) {
        let obj = {};
        let filterValues = _.filter(field.options, (o) => {
          return o.value == values;
        });

        if (filterValues && filterValues.length > 0) {
          SelectedArrtObj.push(filterValues[0]);
        }
      });
      // console.log("SelectedArrtObj :- ", SelectedArrtObj);

      if (_.size(SelectedArrtObj) > 0) {
        field.input.value = SelectedArrtObj;
      }
    }

    return (
      <div className={divClassName}>
        {field.label && field.label !== "" ? (
          <>
            <label className={labelClasses}>
              {field.label}
              <span className="label-mandatory">
                {field.mandatory === "true" ? "*" : ""}
              </span>

              {field.labelinfo && field.labelinfo !== "" ? (
                <OverlayTrigger
                  key="auocompleteasync"
                  placement="right"
                  overlay={
                    <Tooltip
                      id="tooltip-category"
                      style={{ marginTop: "-5px" }}
                    >
                      <div className="custom-text1-white-normal">
                        {field.labelinfo}
                      </div>
                    </Tooltip>
                  }
                >
                  <img
                    src="../../style/images/header-icons/infoicon.png"
                    className="ml-10 pointer"
                    alt="info icon"
                  />
                </OverlayTrigger>
              ) : (
                ""
              )}
            </label>
          </>
        ) : (
          ""
        )}
        <div
          className={`${inputClasses} creatable-selectbox`}
          style={{ position: "relative" }}
        >
          <CreatableSelect
            {...field.input}
            className="react-multi-select-custom-css"
            placeholder={field.placeholder}
            value={field.input.value || ""}
            labelKey={field.labelKey}
            valueKey={field.valueKey}
            isMulti={field.isMulti ? true : false}
            options={field.options}
            onBlur={() => field.input.onBlur(field.input.value)}
            isClearable
            isDisabled={field.disabled === true ? true : false}
            menuPosition="absolute"
            maxMenuHeight={160}
          />

          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>

          {field.maxlength ? (
            <span className="char-left">
              {field.input.value.length}
              {" / "}
              {field.maxlength}
            </span>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }

  renderFiledWhatsapp(field) {
    return (
      <div className="form-group">
        <label>{field.label}</label>
        <select className="form-control dropdown-height-border">
          <option value="">{field.placeholder}</option>
          {_.map(field.opts, (item) => {
            return <option value={item.value}>{item.name}</option>;
          })}
        </select>
        <input
          className="form-control"
          type={field.type}
          {...field.input}
          disabled={field.disabled === true ? true : false}
          maxLength={field.maxlength ? field.maxlength : ""}
        />
      </div>
    );
  }

  renderFieldCheckbox(field) {
    return (
      <div>
        <label
          className="custom-container-checkbox"
          style={{ marginBottom: 5 }}
        >
          {field.label}
          <input type={field.type} {...field.input} />
          <span className="checkmark" />
        </label>
      </div>
    );
  }

  renderFieldToggleButton(field) {
    return (
      <div className="vertical-align-center">
        <label className="switch-button-container">
          <input type={field.type} {...field.input} />
          <span className="switch-slider switch-round" />
        </label>
        <span>{field.label}</span>
      </div>
    );
  }

  renderFieldRadio(field) {
    var formdiv = "";
    if (field.formdiv) {
      formdiv = field.formdiv;
    }

    return (
      <div className={`mr-10 ${formdiv}`}>
        <label className="custom-container-radio">
          {field.label}
          <input
            {...field.input}
            type={field.type}
            disabled={field.disabled ?? false}
          />
          <span className="radiomark"></span>
        </label>
      </div>
    );
  }

  renderColorPickerField(field) {
    let { labelposition, displayColorPicker } = field;
    var divClassName = `form-group row position-relative ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName}`;
    var labelClasses = "control-label col-sm-3";
    var inputClasses = "col-sm-9 col-sm-offset-0 ";

    if (labelposition === LABEL_POSITION_TOP) {
      labelClasses = "control-label-top col-sm-12";
      inputClasses = "col-sm-12 col-sm-offset-0";
    }

    const styles = reactCSS({
      default: {
        color: {
          width: "40px",
          height: "30px",
          borderRadius: "2px",
        },
        swatch: {
          padding: "5px",
          background: "#ffffff",
          borderRadius: "1px",
          boxShadow: "0 0 0 1px rgba(0,0,0,.1)",
          display: "inline-block",
          cursor: "pointer",
        },
        popover: {
          position: "absolute",
          zIndex: "2",
        },
        cover: {
          position: "fixed",
          top: "0px",
          right: "0px",
          bottom: "0px",
          left: "0px",
        },
      },
    });

    return (
      <div className={divClassName}>
        {field.label && field.label !== "" ? (
          <label className={labelClasses}>
            {field.label}
            <span className="label-mandatory">
              {field.mandatory === "true" ? "*" : ""}
            </span>
          </label>
        ) : null}
        <div className={inputClasses}>
          <div className="vertical-align-center">
            <div style={styles.swatch}>
              <button
                style={{ ...styles.color, background: field.input.value }}
                type="button"
                onClick={field.onClick}
              ></button>
            </div>
            <input
              className="form-control"
              style={field.hideInput ? { display: "none" } : {}}
              type={field.type}
              placeholder={field.placeholder}
              {...field.input}
              readOnly={true}
            />
          </div>

          {displayColorPicker ? (
            <div className="compact-picker-container" style={styles.popover}>
              <div style={styles.cover} onClick={field.handlePickerClose} />
              <SketchPicker
                color={field.input.value}
                onChangeComplete={field.onChangeComplete}
              />
            </div>
          ) : null}

          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>
      </div>
    );
  }

  renderCompactColorPickerField(field) {
    var { labelposition, displayColorPicker, colorsArr, styles } = field;
    var divClassName = `form-group row position-relative ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName}`;
    var labelClasses = "control-label col-sm-3";
    var inputClasses = "col-sm-9 col-sm-offset-0 ";

    if (labelposition === LABEL_POSITION_TOP) {
      labelClasses = "control-label-top col-sm-12";
      inputClasses = "col-sm-12 col-sm-offset-0";
    }

    /**
     * NOTE:
     * A new param 'defaultValue' is used same as input value.
     * It is observed in the schedule-bull-edit implementation that from the second time
     * the input.value data is not getting updated. This needs to be checked, currently it is
     * solved with this non-suggested manner.
     *
     * Use this props only if the same error occurs
     */
    if (field.defaultValue != null) field.input.value = field.defaultValue;

    return (
      <div className={divClassName}>
        {field.label && field.label !== "" ? (
          <label className={labelClasses}>
            {field.label}
            <span className="label-mandatory">
              {field.mandatory === "true" ? "*" : ""}
            </span>
          </label>
        ) : null}
        <div className={inputClasses}>
          <div className="vertical-align-center">
            <div style={styles.swatch}>
              <button
                style={{ ...styles.color, background: field.input.value }}
                type="button"
                onClick={field.onClick}
              ></button>
            </div>
            <input
              className="form-control"
              type={field.type}
              placeholder={field.placeholder}
              {...field.input}
              readOnly={true}
            />
          </div>

          {displayColorPicker ? (
            <div className="compact-picker-container" style={styles.popover}>
              <div style={styles.cover} onClick={field.handlePickerClose} />
              <CompactPicker
                colors={colorsArr}
                color={field.input.value}
                onChangeComplete={field.onChangeComplete}
              />
            </div>
          ) : null}

          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>
      </div>
    );
  }

  renderFieldSimpleColorPicker(field) {
    return (
      <div className="">
        <label
          className="custom-container-simple-colorpicker"
          style={{ display: "flex", gap: 14 }}
        >
          <div className="">
            <input type={field.type} {...field.input} value={field?.values} />
          </div>
          <div className="">{field.label}</div>
        </label>
      </div>
    );
  }

  renderTimeInputMask(field) {
    // ----- Styling section
    let charactersLeft = "";
    var labelposition = field.labelposition;
    var formdiv = "";
    if (field.formdiv !== undefined && field.formdiv === "false") {
      formdiv = "";
    }
    var divClassName = `form-group row ${formdiv} ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName} ${field.bsClass ? field.bsClass : ""}`;
    var labelClasses = "control-label col-sm-3";
    var inputClasses = "col-sm-9 col-sm-offset-0";

    if (labelposition === LABEL_POSITION_TOP) {
      labelClasses = "control-label-top col-sm-12";
      inputClasses = "col-sm-12 col-sm-offset-0";
    }

    // ----- Masking section
    const handleOnchange = (e) => {
      let time_str = e.target.value.replace(/_/g, ""); // masking _ chanr replaced
      time_str = time_str == ":" ? "" : time_str; // colon replaced

      // handling hour section, restricting to 23
      if (new Number(time_str[0]) == 2 && new Number(time_str[1]) >= 4)
        e.target.value = "2";
      // shows only 2 instead of 2_:__ when input[1] > 3, but if <= 3 is typed again falls bak to 23:__ format
      else {
        let time_arr = time_str.split(":"); // splitig to check '12 & '34' of time 12:34

        // as excepts only string
        if (
          typeof time_str == "string" &&
          time_arr[0].length == 2 &&
          time_arr[1].length == 2
        ) {
          field.handleOnChange(moment(`${field.selectedDate} ${time_str}:00`));
        }
      }
    };

    return (
      <div className={divClassName}>
        {field.label && field.label !== "" ? (
          <label className={labelClasses}>
            {field.label}
            <span className="label-mandatory">
              {field.mandatory === "true" ? "*" : ""}
            </span>

            {field.labelinfo && field.labelinfo !== "" ? (
              <OverlayTrigger
                key="auocompleteasync"
                placement="right"
                overlay={
                  <Tooltip id="tooltip-category" style={{ marginTop: "-5px" }}>
                    <div className="custom-text1-white-normal">
                      {field.labelinfo}
                    </div>
                  </Tooltip>
                }
              >
                <img
                  src="../../style/images/header-icons/infoicon.png"
                  className="ml-10 pointer"
                  alt="info icon"
                />
              </OverlayTrigger>
            ) : (
              ""
            )}
          </label>
        ) : null}
        <div className={inputClasses} style={{ position: "relative" }}>
          <InputMask
            className="form-control text-center"
            mask="29:59" // input not accepted beyond this value, hour > 23 handled with onChange
            maskChar={"_"} // __:__
            // masking character definations (limits of each char)
            formatChars={{
              2: "[0-2]",
              9: "[0-9]",
              5: "[0-5]",
            }}
            alwaysShowMask // if "" comes as value, mask will appear
            defaultValue={
              // accepts only HH:mm format
              field.timeValue ? field.timeValue.format("HH:mm") : ""
            }
            onChange={handleOnchange} // local onChange handler
          />

          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>
      </div>
    );
  }
}
